export default __webpack_public_path__ + "static/media/batt.9ec83bc3.svg";